// extracted by mini-css-extract-plugin
export default {"cont":"LoginView_cont__Azvej","fGroup":"LoginView_fGroup__iSzFC","control":"LoginView_control__N-Cz0","btn":"LoginView_btn__Nd2kj","other":"LoginView_other__ZkhGy"};